module.exports = __webpack_public_path__ + "media/images/countrysquared/gr-835ba302142b2644e8d5192bc01aa5f8.svg";